import { useState, useEffect, Dispatch, SetStateAction } from 'react'

type IntersectionObserverInit = globalThis.IntersectionObserverInit

export const useOnScreen = <T extends HTMLElement>(
  options: IntersectionObserverInit,
): [Dispatch<SetStateAction<T | null>>, boolean] => {
  const [ref, setRef] = useState<T | null>(null)
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.isIntersecting)
    }, options)

    if (ref && !visible) {
      observer.observe(ref)
    }

    return () => {
      if (ref) {
        observer.unobserve(ref)
      }
    }
  }, [ref, options])

  return [setRef, visible]
}

export default useOnScreen
